


import React, {useContext} from 'react'
import {ThemeContext} from 'styled-components'
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import { Text } from 'rebass'


interface InsufficientModalProps extends ModalProps {
  text?: string
}

const InsufficientModal: React.FC<InsufficientModalProps> = (any: {}) => {
  const theme = useContext(ThemeContext)
  return (
    <Modal maxWidth={400} backgroundColor={theme.bsBg36} padding={'10px 20px'}>
      <Text color={theme.bsText28} fontFamily={'Roboto-Bold'} textAlign='center' fontSize={22} lineHeight={'40px'}>
        Insufficient balance
      </Text>
    </Modal>
  )
}

export default InsufficientModal